import React from 'react'
import {connect} from 'react-redux'
import moment from "moment";
import {Col, Row, Button} from "react-bootstrap";
import store from "../store";
import {getTokenList, revokeTokenByValue} from "../providers/providers";
import {withRouter} from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import {Spinner} from "react-bootstrap";
import DisplayStatus from "./DisplayStatus";
import BaseComponent from "./BaseComponent";
const Translate = require('react-redux-i18n').Translate;
const I18n = require('react-redux-i18n').I18n;


const stateMap = (store) => {
    return {
        user: store.user
    };
};

const NoDataIndication = () => (
    <div className="no-data-msg">
        <Translate value="table.noData" />
    </div>
);


class AccessTokens extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            pageSize: process.env.PAGE_SIZE ? parseInt(process.env.PAGE_SIZE): 10,
            page: 1,
            accessTokens: null,
            sortField: null,
            sortOrder: null,
            totalSize: 0,
            tokenDeletedMsg: undefined,
            showMsg: false,
            statusType: undefined
        };


        this.handleTableChange = this.handleTableChange.bind(this)
        this.scopesFormatter = this.scopesFormatter.bind(this)
        this.datesFormatter = this.datesFormatter.bind(this)
        this.headerFormatter = this.headerFormatter.bind(this)
        this.revokeFormatter = this.revokeFormatter.bind(this)
        this.handler = this.handler.bind(this)
        this.deleteItem = this.deleteItem.bind(this)
        this.handleAlert = this.handleAlert.bind(this)


        this.handler(null, null)
    }



    deleteItem(item) {
        store.dispatch(revokeTokenByValue(item)).then(() => {

            this.setState({
                tokenDeletedMsg: I18n.t("table.deletion.success"),
                showMsg: true,
                statusType: "success"
            }, ()=> {
                this.handler(this.state.sortField, this.state.sortOrder, this.state.page)
            })
        }, (error) => {
            this.setState({
                tokenDeletedMsg: I18n.t("table.deletion.error"),
                showMsg: true,
                statusType: "error"
            })
                return Promise.reject(error)
            })

    }

    handleAlert(show){
        this.setState({
            showMsg: show
        })
    }


    scopesFormatter(cell, row) {
        return (
            <div className='scopes-cell--wrapper'>
                <div className='scopes-cell'>
                {
                cell && cell.length > 0 ?
                    cell.map((scope, idx) => {
                        return <span key={row + '-scope-' + idx}>{scope}</span>
                    })
                    : "-"}
                </div>
            </div>
        );
    }

    datesFormatter(cell, row) {
        return (
            cell  ?
                moment(cell).format('DD/MM/YY, hh:mm:ss A')
                : "-"
        );
    }

    headerFormatter (column, index, {sortElement, filterElement}) {
        const order = sortElement.props;
        return (
        <div className="dates-header-wrapper" title={I18n.t("table.hover.sortColumn")}>
            <Translate value={column.text} dangerousHTML/>
            <span>{order.children}</span>
        </div>
        )
    }

    revokeFormatter(cell, row) {
        return (
            cell  ?
                <Button variant="outline-danger"
                        title={I18n.t("table.hover.deleteToken")}
                        className="revoke-btn"
                        onClick={() => {
                        this.deleteItem(cell)
                }} >
                    <span className="fa fa-trash" />
                </Button>
                : "-"
        );
    }

    handleTableChange = (type, {page, sizePerPage, sortField, sortOrder}) => {
        this.setState({
            page: page,
            sortField: sortField,
            sortOrder: sortOrder
        }, () => {
           this.handler()
        })
    };

    static sortCaret(order, column) {
        if (!order) {
        return <React.Fragment>
                <span className='fa fa-caret-up' />
                <span className='fa fa-caret-down' />
                </React.Fragment>
        } else if (order === 'asc') {
            return <React.Fragment>
                        <span className='fa fa-caret-down' />
                    </React.Fragment>
        } else {
            return <React.Fragment>
                    <span className='fa fa-caret-up' />
                    </React.Fragment>
        }
    }

    handler() {
        store.dispatch(getTokenList(this.state.page, this.state.pageSize, this.state.sortField, this.state.sortOrder)).then((response) => {
        let tokens = response.value.data;
        let total = parseInt(response.value.headers['x-meta-total-elements'], 0);
            this.setState({
                accessTokens: tokens,
                totalSize:  total ? total : 0
            })
        });
        return Promise.resolve()

    }

    render() {
        const columns = [
            {
                dataField: 'uid',
                text: 'uid'
            },
            {
                dataField: "name",
                text: "Name"
            },
            {
                dataField: "clientId",
                text: "Application Id"
            },
            {
                dataField: 'scope',
                text: 'Scopes',
                formatter: this.scopesFormatter,
                classes: "scopes-cell--col"
            },
            {
                dataField: 'createdOn',
                text: 'Created On',
                headerFormatter: this.headerFormatter,
                formatter: this.datesFormatter,
                sortCaret: AccessTokens.sortCaret,
                sort: true
            },
            {
                dataField: 'expiredOn',
                text: 'Expired On',
                headerFormatter: this.headerFormatter,
                formatter: this.datesFormatter,
                sortCaret: AccessTokens.sortCaret,
                sort: true
            },
            {
                dataField: 'value',
                text: 'Revoke',
                formatter: this.revokeFormatter,
                classes: "table-col-revoke-cell"
            }
        ];

        let options = {
            hideSizePerPage: true,
            pageStartIndex: 1,
            alwaysShowAllBtns: this.state.totalSize > 10,
            withFirstAndLast: true,
            hidePageListOnlyOnePage: true,
            prePageText: I18n.t("table.pagination.previous"),
            nextPageText: I18n.t("table.pagination.next"),
            firstPageText: I18n.t("table.pagination.first"),
            lastPageText: I18n.t("table.pagination.last"),
            showTotal: this.state.totalSize > 10,
            page: this.state.page,
            sizePerPage: this.state.pageSize,
            onTableChange: this.handleTableChange,
            totalSize: this.state.totalSize
        };

        return (
            <Row className="justify-content-md-center">
                    {this.state.accessTokens ?
                        <Col lg="8">
                            <div className="display-status--wrapper">
                                <DisplayStatus
                                    statusMessage={this.state.tokenDeletedMsg}
                                    statusType={this.state.statusType}
                                    showAlert={this.state.showMsg}
                                    handleAlert={this.handleAlert}
                                    dismissible={true}
                                />
                            </div>
                            <div className = {"tokens-table--wrapper" +
                            (!this.state.showMsg ? " table-margin-top" : "") +
                            (!this.props.user.tokenList.fetching ? " table-margin-bottom" : "")
                            }>
                                <BootstrapTable
                                    pagination={paginationFactory(options) }
                                    bootstrap4
                                    remote
                                    keyField='value'
                                    data={this.state.accessTokens}
                                    onTableChange={this.handleTableChange}
                                    columns={columns}
                                    classes="tokens-table"
                                    noDataIndication={ () => <NoDataIndication /> }
                                />
                            </div>
                         </Col>:null}
                    {this.props.user && this.props.user.tokenList.fetching ?
                        <div className='loader-wrapper'>
                            <Spinner animation="border" variant="info" className="spinner__custom-clr" />
                        </div>: null}
            </Row>
        )
    }
}

export default withRouter(connect(stateMap)(AccessTokens));



